import { LazyImage } from '@crehana/compass.ui';
import { cn } from '@crehana/compass.ui/v2';
import { DEFAULT_IMG_CONTENT } from "../constants";
import { jsx as _jsx } from "react/jsx-runtime";
var COMMON_COVER_CLASSNAME = 'tw-w-full tw-h-14.4';
var CourseCover = function CourseCover(_ref) {
  var title = _ref.title,
    coverImage = _ref.coverImage,
    sizeImage = _ref.sizeImage;
  return /*#__PURE__*/_jsx(LazyImage, {
    alt: title,
    src: coverImage,
    placeholder: DEFAULT_IMG_CONTENT,
    className: cn(COMMON_COVER_CLASSNAME, sizeImage),
    imgClassName: "tw-object-cover tw-w-full tw-h-full",
    imgxParams: {
      fit: 'crop',
      crop: 'faces',
      w: 260,
      h: 144,
      q: 100
    }
  });
};
export default CourseCover;